import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

interface LoadingStateProps {
  title?: string;
  description?: string;
  minimal?: boolean;
}

export function LoadingState({ 
  title = "Wird geladen …", 
  description = "Bitte warten Sie einen Moment",
  minimal = false,
}: LoadingStateProps) {
  if (minimal) {
    return (
      <div className="flex items-center justify-center gap-3 py-8">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="text-sm text-muted-foreground">{title}</span>
      </div>
    );
  }

  return (
    <Card className="border-border/40 animate-fade-in">
      <CardContent className="flex flex-col items-center justify-center py-16 gap-4">
        <div className="relative">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <div className="absolute inset-0 h-8 w-8 animate-ping opacity-20 rounded-full bg-primary" />
        </div>
        <div className="text-center space-y-1">
          <p className="text-sm font-medium text-foreground">
            {title}
          </p>
          <p className="text-xs text-muted-foreground">
            {description}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}